import useProject from "hooks/useProject";
import { useMemo } from "react";

type EndpointGetter = (projectId: string, ...rest: unknown[]) => string;

export default function useProjectEndpoint(
  endpointGetter: EndpointGetter,
  ...rest: unknown[]
): string {
  const { projectId: projectId } = useProject();

  return useMemo(() => endpointGetter(projectId, ...rest), [rest, projectId]);
}
